// Add to Cart Handler
async function handleAddToCart(event) {
  event.preventDefault();

  const form = event.target;
  const submitButton = form.querySelector('button[type="submit"]');
  const data = new FormData(form);
  const locale = document.documentElement.lang || window.themeLocale || 'de';

  // Button deaktivieren
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.textContent = 'Wird hinzugefügt...';
  }

  try {
    // 1) Produkt zum Warenkorb hinzufügen
    const resp = await fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/")+"cart/add.js", {
      method: 'POST',
      body: data,
      headers: { Accept: 'application/json' },
    });

    if (!resp.ok) {
      const json = await resp.json();
      throw new Error(json.description || 'Fehler beim Hinzufügen');
    }

    // 2) Cart-Inhalt und Badge aktualisieren
    if (typeof window.refreshCartContent === 'function') {
      // Verwende die refreshCartContent Funktion aus off-canvas.js
      // Diese aktualisiert sowohl den Cart-Inhalt als auch das Badge
      await window.refreshCartContent();
    } else {
      // Fallback: Manuelle Aktualisierung
      const cartData = await fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/")+"cart.js").then((r) => r.json());

      // Badge aktualisieren
      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        badge.textContent = cartData.item_count;
        badge.style.display = cartData.item_count > 0 ? 'flex' : 'none';
      });

      // Cart-Inhalt aktualisieren
      try {
        const resp = await fetch(window.location.href, { headers: { Accept: 'text/html' } });
        const html = await resp.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newCart = doc.querySelector('#cart-content');
        const oldCart = document.querySelector('#cart-content');

        if (newCart && oldCart) {
          oldCart.innerHTML = newCart.innerHTML;
        }
      } catch (e) {
        console.error('Fehler beim Aktualisieren des Cart-Inhalts:', e);
      }
    }

    // 5) Off-Canvas öffnen
    if (typeof window.openOffCanvas === 'function') {
      window.openOffCanvas('cart-panel');
    } else {
      const wrapper = document.getElementById('cart-panel');
      const panel = wrapper?.querySelector('[data-off-canvas-panel]');
      if (wrapper && panel) {
        wrapper.classList.remove('hidden');
        setTimeout(() => panel.classList.remove('translate-x-full'), 10);
      }
    }
  } catch (err) {
    alert('Fehler: ' + err.message);
  } finally {
    // Button wieder aktivieren
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = submitButton.getAttribute('data-available-text') || 'In den Warenkorb';
    }
  }
}

// Global verfügbar machen
window.handleAddToCart = handleAddToCart;

// Event Listener für alle Product Forms
document.addEventListener('submit', function (event) {
  const form = event.target;

  // Ist es ein Product Form?
  const action = form.getAttribute('action') || '';
  const isProductForm = action.includes('/cart/add') || action.includes('cart_add_url') || form.id === 'AddToCartForm';

  if (isProductForm) {
    handleAddToCart(event);
  }
});
